(function($) {
	$.fn.multiRowFix = function(options) {
		var config = {
			numCols: 0
		};
		if (options) {
			$.extend(config, options);
		}
		return this.each(function() {
			var self = this;
			var moduleBody = $('div[class*="ds-content-inner"]', self);
			
			var currentCount = 0;
			var currentHighest = 0;
			var numListItems = 0;
			var currentLinkList = null;
			
			//for each linkList in that module
			moduleBody.find('.ds-product-list').each(function(listNum) {
			
				var currentLinkList = $(this);
				var currentCount = 0;
				var currentHighest = 0;
				var $listItems = currentLinkList.children();
				var numListItems = $listItems.length;
				
				$listItems.each(function(n) {
					
					if (config.numCols > 0) {
						currentCount = n % config.numCols;
					} else {
						currentCount = n;
					}
					
					//if this is the tallest li in the row so far, remember its height
					if ($(this).height() > currentHighest) {
						currentHighest = $(this).height();
					}
					
					// if at the end of a row or have run out of list items, then set heights in that row
					if ((config.numCols > 0 && currentCount >= (config.numCols - 1)) || n >= (numListItems - 1)) {
						for (m = 0; m <= currentCount; m++) {
							if ($.browser.msie && $.browser.version < 7) {
								$listItems.eq(n - m).css('height', currentHighest + 'px');
							} else {
								$listItems.eq(n - m).css('min-height', currentHighest + 'px');
							}
						}
						currentHighest = 0;
					}
				});
			});
		});
	};
})(jQuery);


